import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { Body3 } from '../Typography';

export const Legal = styled.div`
  background-color: ${themeGet('colors.greys.1')};
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
`;

export const StyledBody3 = styled(Body3)`
  margin: 0px;
`;
